<script>
import {mapState} from "vuex";

export default {
  name: "LimitReachedPopUp",
  computed: {
    ...mapState(['isFreeUser'])
  },
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
}
</script>

<template>
  <div class="tutorialOverlay" @click="closeModal">
      <div class="d-flex flex-column justify-content-center align-items-center col-12" style="height: 90svh;">
          <div class="d-flex flex-column justify-content-center align-items-center col-10 limit-modal-content ">
            <div class="d-flex justify-content-start align-items-center col-10 position-relative" style="height: 20vh">
              <div class="d-flex flex-column justify-content-center align-items-start col-6">
                <div class="col-12 heading-limit-text">Daily Limited Reached</div>
                <div class="col-12 body-limit-text mt-3">
                 <span class="fw-bold"> Rest-up Rockstar</span> <br></br>  you’ve played your daily quiz. Come back tomorrow for more music quizzes!
                </div>
              </div>
              <img style="position: absolute; right: -16%" src="@/assets/home/limit-pop-up-asset.png" class="col-6" />
            </div>
            <div v-if="isFreeUser" class="col-5 mb-3 fw-bold p-3 text-center limit-btn" @click="this.$router.push('/upgrade')">Upgrade</div>
            <div v-else class="col-5 mb-3 fw-bold p-3 text-center limit-btn" @click="closeModal" >Close</div>
          </div>
      </div>
  </div>
</template>

<style scoped>
.limit-btn {
  border: 1px solid rgba(255, 255, 255, 0.85) ;
  border-radius: 29px;
  background: #FFCB05;
  font-size: 14px;
}

.body-limit-text {
  color: #000F56;
  font-size: 12.51px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.heading-limit-text {
  color: #000F56;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.tutorialOverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: #000015B2;
  backdrop-filter: blur(7px);
}

.limit-modal-content {
  border-radius: 11px;
  border: 2px solid #4A5488;
  background: rgba(255, 255, 255, 0.85);
  z-index: 11;
}
</style>